import { IModel, IAttribute } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { SSLMode } from '../../registries/consts/mysql-consts';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { getSqlPEResourceIDAndName, IPrivateEndpointCompatible } from 'shell-models-lib';

@Metamodel.model({
    name: adfModelTypeMap.azureMySql.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AzureMySql_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.AzureMySql_DisplayText)
    ]
})
export class AzureMySqlLinkedService extends LinkedService implements IPrivateEndpointCompatible {

    public static readonly MODEL: IModel;
    public static readonly SERVER_NAME: IAttribute;
    public static readonly DATABASE_NAME: IAttribute;
    public static readonly PORT: IAttribute;
    public static readonly USER_NAME: IAttribute;
    public static readonly PASSWORD: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServerName,
        association: 'SERVER_NAME',
        templatable: true
    })
    public serverName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Port,
        association: 'PORT',
        templatable: true,
        accepts: ['String', 'Int']
    })
    public port?: number = 3306;

    @Metamodel.attribute({
        display: stringResources.ModelName_DatabaseName,
        association: 'DATABASE_NAME',
        templatable: true
    })
    public databaseName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName,
        association: 'USER_NAME',
        templatable: true
    })
    public userName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'PASSWORD',
        templatable: true,
        accepts: ['String']
    })
    public password?: string | AzureKeyVault;

    public enableAKV?: boolean = false;
    @Metamodel.attribute({
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public referedAKV?: AzureKeyVault;

    public sslMode?: SSLMode = SSLMode.Preferred;
    public useSystemTrustStore?: boolean = false;

    private _serverResourceID: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public getPEResourceIDAndName(): { id: string, name: string } {
        return getSqlPEResourceIDAndName(this.serverName, this._serverResourceID);
    }

    public setPEResourceID(id: string): void {
        this._serverResourceID = id;
    }
}
